<!-- 
System: GIGSTIMER
Developer(s): Fatima Saeed, Jazib Nasir
Date: 
Organization: Programmers Force
Purpose: Allows switching between payment chart and payment process
-->
<template>
  <div :class="isMac ? 'edited_scrollbar' : ''">
    <div v-if="getRestrictStatus" class="mt-n16">
      <Error403 />
    </div>
    <div
      v-else
      style="height: 90vh"
      :class="$vuetify.breakpoint.xs ? 'mx-7 mt-2 y-scroll' : 'mx-8 mt-6'"
    >
      <v-tabs show-arrows v-model="tabs" color="#2A206A" class="setting-tabs">
        <!-- Payment Chart Tab -->
        <v-tab
          v-show="
            (getSelectedCompany.subscribed_plan == null ||
              (getSelectedCompany.subscribed_plan &&
                getSelectedCompany.subscribed_plan.toLowerCase() == 'basic') ||
              (getSelectedCompany.subscribed_plan &&
                getSelectedCompany.subscribed_plan.toLowerCase() ==
                  'unlimited_plan') ||
              changePlan == true) &&
            (getSelectedCompany.role == 'owner' ||
              getSelectedCompany.role == 'admin')
          "
          class="text-capitalize  setting-tabs"
          href="#chart-tab"
          >Payment Chart</v-tab
        >
        <!-- Payment Process Tab -->
        <v-tab
          v-show="
            getSelectedCompany.subscribed_plan &&
            getSelectedCompany.subscribed_plan.toLowerCase() != 'basic' &&
            getSelectedCompany.subscribed_plan.toLowerCase() !=
              'unlimited_plan' &&
            (getSelectedCompany.role == 'owner' ||
              getSelectedCompany.role == 'admin')
          "
          class="text-capitalize mt-3 setting-tabs"
          href="#gateway-tab"
          >Payment Process</v-tab
        >
      </v-tabs>

      <v-divider style="border: 1px solid #edebf9"></v-divider>
      <v-tabs-items class="mt-4 transparent" v-model="tabs">
        <!-- Display when Personal Info tab is clicked -->

        <!-- Display when Company Info tab is clicked -->
        <!--Importing Payment Chart Page -->
        <v-tab-item
          value="chart-tab"
          v-show="
            (getSelectedCompany.subscribed_plan == null ||
              (getSelectedCompany.subscribed_plan &&
                getSelectedCompany.subscribed_plan.toLowerCase() == 'basic') ||
              (getSelectedCompany.subscribed_plan &&
                getSelectedCompany.subscribed_plan.toLowerCase() ==
                  'unlimited_plan') ||
              changePlan == true) &&
            (getSelectedCompany.role == 'owner' ||
              getSelectedCompany.role == 'admin')
          "
        >
          <Chart />
        </v-tab-item>
        <!--Importing Billing Page -->
        <v-tab-item
          value="gateway-tab"
          v-show="
            getSelectedCompany.subscribed_plan &&
            getSelectedCompany.subscribed_plan.toLowerCase() != 'basic' &&
            getSelectedCompany.subscribed_plan.toLowerCase() !=
              'unlimited_plan' &&
            (getSelectedCompany.role == 'owner' ||
              getSelectedCompany.role == 'admin')
          "
        >
          <Billing />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <!-- getting Credit Card -->
    <AddCreditCard />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Billing from "@/components/Payment/Billing";
import Chart from "@/components/Payment/PaymentChart";
import AddCreditCard from "@/components/Payment/AddCreditCard";
import { eventBus } from "@/main";
export default {
  data() {
    return {
      tabs: null,
      changePlan: false,
    };
  },
  computed: {
    ...mapGetters(["getSelectedCompany", "getIpPolicy", "getRestrictStatus"]),
  },

  components: {
    Chart,
    AddCreditCard,
    Billing,
    Error403: () => import("@/components/Includes/403.vue"),
  },
  mounted() {
    // if company subscribed plan is not null or basic or unlimited, Go to "gateway-tab" otherwise Go to "chart-tab"
    if (
      this.getSelectedCompany.subscribed_plan &&
      this.getSelectedCompany.subscribed_plan.toLowerCase() != "basic" &&
      this.getSelectedCompany.subscribed_plan != "unlimited_plan"
    ) {
      this.tabs = "gateway-tab";
    } else {
      this.tabs = "chart-tab";
    }
    // Switch Tab
    eventBus.$on("switchTab", (data) => {
      this.tabs = data;
    });
    // Go to "chart-tab" for updating subscription plan
    eventBus.$on("updatePlan", (data) => {
      this.changePlan = data;
      if (this.changePlan) {
        this.tabs = "chart-tab";
      } else {
        this.tabs = "gateway-tab";
      }
    });
  },
};
</script>
<style>
.setting-tabs .v-tab--active {
  background-color: #e1ddf5 !important;
  font-weight: bold !important;
}
.setting-tabs .v-tabs-slider {
  height: 0px !important;
}
</style>
